import { render, staticRenderFns } from "./distributionTask.vue?vue&type=template&id=05443889&scoped=true&"
import script from "./distributionTask.vue?vue&type=script&lang=js&"
export * from "./distributionTask.vue?vue&type=script&lang=js&"
import style0 from "./distributionTask.vue?vue&type=style&index=0&id=05443889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05443889",
  null
  
)

export default component.exports